import { render, staticRenderFns } from "./Vergelijkingspunten.vue?vue&type=template&id=271d34a3"
import script from "./Vergelijkingspunten.vue?vue&type=script&lang=js"
export * from "./Vergelijkingspunten.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports